<template>
  <div class="wrap" ref="wrap">
    <a-space direction="vertical" style="width: 100%;" size="middle">
      <a-row type="flex">
        <a-space>
          <a-space>
            <span>标题: </span>
            <a-input placeholder="输入标题模糊查询" style="width: 200px" v-model="fuzzyMap.title"
              @keyup.enter.native="search" />
          </a-space>
          <a-space>
            <a-button type="primary" @click="search">搜索</a-button>
            <a-button type="primary" @click="reset">重置</a-button>
            <a-button type="primary" @click="openDeleteModal">删除</a-button>
          </a-space>
        </a-space>
      </a-row>
      <a-row type="flex">
        <a-space>
          <a-select placeholder="请选择科目" :value="firstProjectName" @change="firstHandleChange">
            <a-select-option :value="item.id || item.name" v-for="item in firstOptions" :key="item.id">{{ item.name
              }}</a-select-option>
          </a-select>
          <a-select v-if="secondOptions.length > 0" placeholder="请选择科目" :value="secondProjectName"
            @change="secondHandleChange">
            <a-select-option :value="item.id || item.name" v-for="item in secondOptions" :key="item.id">{{ item.name
              }}</a-select-option>
          </a-select>
          <a-select v-if="thirdOptions.length > 0" placeholder="请选择科目" :value="thirdProjectName"
            @change="thirdHandleChange">
            <a-select-option :value="item.id || item.name" v-for="item in thirdOptions" :key="item.id">{{ item.name
              }}</a-select-option>
          </a-select>
          <a-select v-if="fourthOptions.length > 0" placeholder="请选择科目" :value="fourthProjectName"
            @change="fourthHandleChange">
            <a-select-option :value="item.id || item.name" v-for="item in fourthOptions" :key="item.id">{{ item.name
              }}</a-select-option>
          </a-select>
          <a-button type="primary" v-if="linkType == 0" @click="addSubject">新增题目</a-button>
          <a-button type="primary" v-if="linkType == 0" @click="showBatchUploadModal()">导入题库</a-button>
          <a-button type="primary" v-if="linkType == 2 || linkType == 4" @click="showUploadFileModal()">上传文件</a-button>
          <a-button type="primary" v-if="linkType == 2 || linkType == 4" @click="viewFile()">预览文件</a-button>
          <a-button type="primary" v-if="linkType == 1" @click="showSetUrlModal()">设置跳转地址</a-button>

        </a-space>
      </a-row>



      <a-table :columns="columns" :data-source="data" size="small" :scroll="tableScroll" :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange
            }" :rowKey="(record) => record.id" :pagination="false" :loading="loading" @resizeColumn="handleResizeColumn">
        <div slot="answerImag" slot-scope="render">
          <template>
            <image :width="200" :height="20" :src="render.first_answer_url" />
          </template>

        </div>
        <div slot="action" slot-scope="render">
          <a @click="modify(render)">修改</a>
          <a-divider type="vertical" />
          <a @click="showSubject(render)">查看详情</a>
          <a-divider type="vertical" />
          <a @click="deleteSubject(render.id)">删除</a>
        </div>
        <a-row slot="footer" type="flex" justify="end">
          <a-pagination v-model="page" :page-size-options="pageSizeOptions" :total="total"
            :show-total="(total) => `共 ${total} 条数据`" show-size-changer :page-size="pageSize"
            @showSizeChange="onShowSizeChange" @change="pageChange" size="small">
            <template slot="buildOptionText" slot-scope="props">
              <span>{{ props.value }}条/页</span>
            </template>
          </a-pagination>
        </a-row>
      </a-table>
    </a-space>


    <!--  导入题目  -->
    <a-modal v-model="batchUploadModalVisible" title="导入题目" :maskClosable="false">
      <a-upload-dragger name="file" :multiple="false" :action="createUploadXlsx" accept=".xlsx"
        :beforeUpload="beforeUpload" :headers="{ 'X-Auth-Token': token }" :remove="() => false" @change="change"
        @reject="reject" :defaultFileList="[]" :fileList="fileList">
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">
          点击或者拖拉文件到此区域去上传
        </p>
        <p class="ant-upload-hint">
          文件格式必须为xlsx，大小2MB以内
        </p>
      </a-upload-dragger>
      <div slot="footer">
        <a-button type="primary" @click="downloadTemplate">下载模板</a-button>
        <a-button @click="batchUploadModalVisible = false">返回</a-button>
      </div>
    </a-modal>

    <!--  上传pdf  -->
    <a-modal v-model="uploadPdfModalVisible" title="上传文件" :maskClosable="false">
      <a-upload-dragger name="file" :multiple="false" :action="createUploadPdfUrl" accept=".pdf,video/mp4"
        :beforeUpload="beforePdfUpload" :headers="{ 'X-Auth-Token': token }" :max-count="1" :remove="() => false"
        @reject="reject" :defaultFileList="[]" :fileList="fileList">
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">
          点击或者拖拉文件到此区域去上传
        </p>
        <p class="ant-upload-hint">
          文件格式为pdf或者mp4，大小4MB以内
        </p>
      </a-upload-dragger>
      <div slot="footer">
        <a-button @click="uploadPdfModalVisible = false">返回</a-button>
      </div>
    </a-modal>

    <!--  设置跳转地址  -->
    <a-modal v-model="setUrlModalVisible" title="设置跳转地址" :maskClosable="false" width="400px">
      <a-row style="margin-bottom: 10px;">
        <a-space>
          <span>科目名称: </span>
          <a-input placeholder="输入用户名模糊查询" disabled style="width: 270px;margin-right:10px" v-model="projectInfo.name" />

        </a-space>

      </a-row>
      <a-row style="margin-bottom: 10px;">

        <a-space>
          <span>跳转地址: </span>
          <a-input placeholder="输入跳转地址" style="width: 270px;margin-right:10px" v-model="projectInfo.url" />

        </a-space>
      </a-row>
      <div slot="footer">
        <a-button type="primary" @click="updateProjectUrl">保存</a-button>
        <a-button @click="setUrlModalVisible = false">返回</a-button>
      </div>
    </a-modal>

    <a-modal v-model="showSubjectModal" width="1000px" :title="subjectModalTitle == 0 ? '新增' : '修改'"
      :maskClosable="false" :afterClose="closeSubjectModal">
      <a-form-model :model="subjectInfo">
        <a-form-model-item label="题目描述">
          <a-row :gutter="24">
            <a-col v-bind="childSpan.col">
              <a-textarea :disabled="textDisabled" v-model='subjectInfo.title' placeholder="请输入题目描述" :rows="2" />
            </a-col>
            <a-col v-bind="imageSpan.col" class="upload-ele">
              <a-upload :file-list="fileListMap.title" @change="titleUploadPhoto" :beforeUpload="beforePhotoUpload"
                :headers="{ 'X-Auth-Token': token }" list-type="picture" class="upload-list-inline"
                :disabled="textDisabled">
                <a-button v-if="fileListMap.title.length < 1 && !textDisabled">
                  <upload-outlined></upload-outlined>
                  upload
                </a-button>
              </a-upload>
            </a-col>
          </a-row>
        </a-form-model-item>
        <a-form-model-item label="答案A">
          <a-row :gutter="24">
            <a-col v-bind="childSpan.col">
              <a-textarea :disabled="textDisabled" v-model='subjectInfo.firstAnswer' placeholder="请输入答案A的描述"
                :rows="2" />
            </a-col>
            <a-col v-bind="imageSpan.col" class="upload-ele">
              <a-upload :file-list="fileListMap.first" @change="firstUploadPhoto" :beforeUpload="beforePhotoUpload"
                :headers="{ 'X-Auth-Token': token }" list-type="picture" class="upload-list-inline"
                :disabled="textDisabled">
                <a-button v-if="fileListMap.first.length < 1 && !textDisabled">
                  <upload-outlined></upload-outlined>
                  upload
                </a-button>
              </a-upload>
            </a-col>
          </a-row>
        </a-form-model-item>
        <a-form-model-item label="答案B">
          <a-row :gutter="24">
            <a-col v-bind="childSpan.col">
              <a-textarea :disabled="textDisabled" v-model='subjectInfo.secondAnswer' placeholder="请输入答案B的描述"
                :rows="2" />
            </a-col>
            <a-col v-bind="imageSpan.col" class="upload-ele">
              <a-upload :file-list="fileListMap.second" @change="secondUploadPhoto" :beforeUpload="beforePhotoUpload"
                :headers="{ 'X-Auth-Token': token }" list-type="picture" class="upload-list-inline"
                :disabled="textDisabled">
                <a-button v-if="fileListMap.second.length < 1 && !textDisabled">
                  <upload-outlined></upload-outlined>
                  upload
                </a-button>
              </a-upload>
            </a-col>
          </a-row>
        </a-form-model-item>
        <a-form-model-item label="答案C">
          <a-row :gutter="24">
            <a-col v-bind="childSpan.col">
              <a-textarea :disabled="textDisabled" v-model='subjectInfo.thirdAnswer' placeholder="请输入答案C的描述"
                :rows="2" />
            </a-col>
            <a-col v-bind="imageSpan.col" class="upload-ele">
              <a-upload :file-list="fileListMap.third" @change="thirdUploadPhoto" :beforeUpload="beforePhotoUpload"
                :headers="{ 'X-Auth-Token': token }" list-type="picture" class="upload-list-inline"
                :disabled="textDisabled">
                <a-button v-if="fileListMap.third.length < 1 && !textDisabled">
                  <upload-outlined></upload-outlined>
                  upload
                </a-button>
              </a-upload>
            </a-col>
          </a-row>
        </a-form-model-item>
        <a-form-model-item label="答案D">
          <a-row :gutter="24">
            <a-col v-bind="childSpan.col">
              <a-textarea :disabled="textDisabled" v-model='subjectInfo.fourthAnswer' placeholder="请输入答案D的描述"
                :rows="2" />
            </a-col>
            <a-col v-bind="imageSpan.col" class="upload-ele">
              <a-upload :file-list="fileListMap.fourth" @change="fourthUploadPhoto" :beforeUpload="beforePhotoUpload"
                :headers="{ 'X-Auth-Token': token }" list-type="picture" class="upload-list-inline"
                :disabled="textDisabled">
                <a-button v-if="fileListMap.fourth.length < 1 && !textDisabled">
                  <upload-outlined></upload-outlined>
                  upload
                </a-button>
              </a-upload>
            </a-col>
          </a-row>
        </a-form-model-item>
        
        <a-form-model-item label="答案E">
          <a-row :gutter="24">
            <a-col v-bind="childSpan.col">
              <a-textarea :disabled="textDisabled" v-model='subjectInfo.fifthAnswer' placeholder="请输入答案E的描述"
                :rows="2" />
            </a-col>
          </a-row>
        </a-form-model-item>
        
        <a-form-model-item label="答案F">
          <a-row :gutter="24">
            <a-col v-bind="childSpan.col">
              <a-textarea :disabled="textDisabled" v-model='subjectInfo.sixthAnswer' placeholder="请输入答案F的描述"
                :rows="2" />
            </a-col>
          </a-row>
        </a-form-model-item>

        <a-form-model-item label="正确答案">
          <a-select v-model="subjectInfo.truthAnswer" :disabled="textDisabled" mode="multiple">
            <a-select-option :value="item.value" v-for="item in answerOptions" :key="item.value">{{ item.label
              }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="答案解析">
          <a-textarea :disabled="textDisabled" v-model='subjectInfo.answerParse' placeholder="请输入答案解析" />
        </a-form-model-item>
      </a-form-model>

      <div slot="footer">
        <a-button type="primary" @click="saveSubject">保存</a-button>
        <a-button @click="showSubjectModal =false">返回</a-button>
      </div>
    </a-modal>
    <a-modal v-model="showDeleteModal" @ok="deleteSubjectByIds()">
      <p>是否确认删除该题目信息？</p>
    </a-modal>
  </div>
</template>
<script>
import { project, subject } from '@/request/api.js';
import { mapState } from 'vuex';

const columns = [
    {
      title: '序号',
      dataIndex: "index",
      align: 'center',
      width: '50px',
      customRender:(text, render, index) => `${index + 1}`
    },
    {
      title: '题目',
      dataIndex: 'title',
      align: 'left',
      resizable: true,
      width: 300,
    },
    {
      title: '答案A',
      dataIndex: 'firstAnswer',
      align: 'left',
      resizable: true,
      width: 200,
    },
    {
      title: '答案B',
      dataIndex: 'secondAnswer',
      align: 'left',
      resizable: true,
      width: 200,
    },
    {
      title: '答案C',
      dataIndex: 'thirdAnswer',
      align: 'left',
      resizable: true,
      width: 200,
    },
    {
      title: '答案D',
      dataIndex: 'fourthAnswer',
      align: 'left',
      resizable: true,
      width: 200,
    },
    {
      title: '答案E',
      dataIndex: 'fifthAnswer',
      align: 'left',
      resizable: true,
      width: 200,
    },
    {
      title: '答案F',
      dataIndex: 'sixthAnswer',
      align: 'left',
      resizable: true,
      width: 200,
    },
    {
      title: '正确答案',
      dataIndex: 'truthAnswer',
      align: 'left',
      width: 100,
    },
    {
      title: '答案解析',
      dataIndex: 'answerParse',
      align: 'left',
      width: 200,
    },
    {
      title: '操作',
      key: 'operation',
      fixed: 'right',
      align: 'center',
      width: 200,
      scopedSlots: { customRender: 'action' },
    },
  ],
  paramColumns = [
    {
      title: '参数名称',
      dataIndex: 'paramName',
      align: 'center',
      width: '100px',
    },
    {
      title: '参数值',
      dataIndex: 'paramValue',
      align: 'center',
      width: '200px',
    },
    {
      title: '操作',
      key: 'operation',
      width: '100px',
      align: 'center',
      scopedSlots: { customRender: 'action' },
    },
  ];

export default {
  data() {
    return {
      showSubjectModal:false,
      previewVisible:false,
      subjectModalTitle:0,
      subjectInfo:{
        title:'',
        fisrtAnswer:'',
        secondAnswer:'',
        thirdAnswer:'',
        fourthAnswer:'',
        fifthAnswer:'',
        sixthAnswer:'',
        truthAnswer:'',
      },
      fileListMap: {
        title:[],
        first:[],
        second:[],
        third:[],
        fourth:[]
      },
      textDisabled: false,
      height: 20,
      linkType:0,
      data: [],
      parentProject:"",
      leafProject:"",
      firstProjectName:"",
      secondProjectName:"",
      thirdProjectName:"",
      fourthProjectName:"",
      options:[],
      projectData:[],
      firstOptions:[],
      secondOptions:[],
      thirdOptions:[],
      fourthOptions:[],
      leafOptions:[],
      answerOptions:[
        {
          value:"A",
          label:"A"
        },
        {
          value:"B",
          label:"B"
        },
        {
          value:"C",
          label:"C"
        },
        {
          value:"D",
          label:"D"
        },
        {
          value:"E",
          label:"E"
        },
        {
          value:"F",
          label:"F"
        }
      ],
      projectId:'',
      projectInfo:{},
      columns,
      // authorizeColumns,
      fuzzyMap: {
        title:''
      },
      auth: [],
      loading: false,
      selectedRowKeys: [],
      dbTypeOptions: [],
      dbType: 'all',
      name: '',
      page: 1,
      pageSize: 10,
      tableScroll: {},
      total: 0,
      pageSizeOptions: ['10', '20', '50'],
      pageAuth: 1,
      pageSizeAuth: 100000000,
      totalAuth: 0,
      visible: false,
      paramForm: {},
      paramList: [],
      paramColumns,
      checkConnectLoading: false,
      sumbitLoading: false,
      batchUploadModalVisible: false,
      uploadPdfModalVisible: false,
      fileList: [],
      //数据源参数配置中新增的行的下标
      parmasIndex: 0,
      setUrlModalVisible: false,
      curItem: {},
      infoAuth: [],
      username: '',
      searchText: '',
      searchInput: null,
      searchedColumn: '',
      qiniuToken:{
        token: ''
      },
      tableScrollAuth: { y: 300 },
      childSpan: {
        col: { span: 16 },
        labelCol: { span: 0 },
        wrapperCol: { span: 24 },
      },
      imageSpan: {
        col: { span: 8 },
        labelCol: { span: 0 },
        wrapperCol: { span: 24 },
      },
      
      form: {
        name: '',
        region: undefined,
        date1: undefined,
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      showDeleteModal:false
    };
  },
  created() {},
  mounted() {
    this.getLeafInfo();
    this.tableScroll = {
      x: document.body.clientWidth - 160,
      y: document.body.clientHeight - 340,
    };
  },
  computed: {
    ...mapState(['token']),
    ...mapState(['userInfo']),
  },
  methods: {
    querySubject() {
      let params = {};
      if (this.page < 1) {
        this.page = 1;
      }
      params.fuzzyMap = this.fuzzyMap;
      params.page = this.page - 1;
      params.size = this.pageSize;

      subject
        .findSubject(this.projectInfo.id, params)
        .then((response) => {
          let total = response.total;
          let data = response.data;
          let loading = false;
          Object.assign(this, {
            data,
            total,
            loading,
          });
        })
        .catch((e) => {
          console.error(e);
          this.loading = false;
        });
    },
    getLeafInfo() {
      // const _this = this;
      project
        .getAllProject()
        .then((projectData) => {
          
          let firstOptions = projectData.filter((item) => !item.parentId);
          Object.assign(this, {
            firstOptions, projectData
          });
          // _this.handleChange(options[0].id)
        })
        .catch((e) => {
          console.error(e);
          this.loading = false;
        });
    },
    addSubject() {
      if (!this.projectInfo.id) {
        this.$message.warn('请先选择科目');
        return ;
      }
      if (this.projectInfo.linkType != 0) {
        this.$message.warn('此科目不能新增题目');
      } else {
        this.subjectModalTitle = 0;
        this.showSubjectModal = !this.showSubjectModal;
      }
    },
    
    saveSubject() {
      this.subjectInfo.truthAnswer = this.subjectInfo.truthAnswer.sort().join(",");
      if (this.subjectModalTitle == 0) {
        this.subjectInfo.projectId = this.projectInfo.id;
        subject.addSubject(this.subjectInfo).then(()=> {
          this.$message.success('新增题目成功');
          this.showSubjectModal = !this.showSubjectModal;
          this.querySubject();
        }).catch((e) => {
          console.error(e);
        });
      } else {
        this.subjectInfo.projectId = this.projectInfo.id;
        subject.modifySubject(this.subjectInfo).then(()=> {
          this.$message.success('修改题目成功');
          this.showSubjectModal = !this.showSubjectModal;
          this.querySubject();
        }).catch((e) => {
          console.error(e);
        });
      }
    },
    
    modify(subjectInfo) {
      this.subjectModalTitle = 1;
      this.subjectInfo = subjectInfo;
      this.setFileListMap(subjectInfo);
      this.showSubjectModal = !this.showSubjectModal;
    },
    // modifySubject() {
    //   console.log("this.subjectInfo=", this.subjectInfo)
    //   this.subjectInfo.projectId = this.projectInfo.id;
    //   subject.modifySubject(this.subjectInfo).then(()=> {
    //       this.$message.success('修改题目成功');
    //       this.showSubjectModal = !this.showSubjectModal;
    //       this.querySubject();
    //     }).catch((e) => {
    //       console.error(e);
    //     });
    // },
    deleteSubject(subjectId) {
      subject.deleteSubject(subjectId).then(()=> {
          this.$message.success('删除题目成功');
          this.querySubject();
        }).catch((e) => {
          console.error(e);
        });
    },
    reject() {
      this.$message.warn('拖拉的文件格式错误');
      return false;
    },
    showSubject(subjectInfo) {
      this.subjectModalTitle = "详情";
      this.textDisabled = true;
      this.subjectInfo = subjectInfo;
      this.setFileListMap(subjectInfo);
      this.showSubjectModal = !this.showSubjectModal;
    },
    closeSubjectModal() {
      let subjectInfo = {
        title:'',
        firstAnswer:'',
        secondAnswer:'',
        thirdAnswer:'',
        fourthAnswer:'',
        truthAnswer:'',
        answerParse:''
      };
      let fileListMap = {
        title:[],
        first:[],
        second:[],
        third:[],
        fourth:[]
      };
      let subjectModalTitle = 0;
      Object.assign(this, {
        subjectInfo, 
        fileListMap, 
        subjectModalTitle
      })
      
      this.textDisabled = !this.textDisabled;
    }, 
    setFileListMap(subjectInfo) {
      if (subjectInfo.titleUrl) {
        let title = {};
        title.name = '标题图片';
        title.uid = subjectInfo.titleUrl;
        title.url = subjectInfo.titleUrl;
        title.thumbUrl = subjectInfo.titleUrl;
        this.fileListMap.title.push(title);
      }
      if (subjectInfo.firstAnswerUrl) {
        let first = {};
        first.name = '答案A图片';
        first.uid = subjectInfo.firstAnswerUrl;
        first.url = subjectInfo.firstAnswerUrl;
        first.thumbUrl = subjectInfo.firstAnswerUrl;
        this.fileListMap.first.push(first);
      }
      if (subjectInfo.secondAnswerUrl) {
        let second = {};
        second.name = '答案B图片';
        second.uid = subjectInfo.secondAnswerUrl;
        second.url = subjectInfo.secondAnswerUrl;
        second.thumbUrl = subjectInfo.secondAnswerUrl;
        this.fileListMap.second.push(second);
      }
      if (subjectInfo.thirdAnswerUrl) {
        let third = {};
        third.name = '答案C图片';
        third.uid = subjectInfo.thirdAnswerUrl;
        third.url = subjectInfo.thirdAnswerUrl;
        third.thumbUrl = subjectInfo.thirdAnswerUrl;
        this.fileListMap.third.push(third);
      }
      if (subjectInfo.fourthAnswerUrl) {
        let fourth = {};
        fourth.name = '答案D图片';
        fourth.uid = subjectInfo.fourthAnswerUrl;
        fourth.url = subjectInfo.fourthAnswerUrl;
        fourth.thumbUrl = subjectInfo.fourthAnswerUrl;
        this.fileListMap.fourth.push(fourth);
      }
    },
    createUploadXlsx() {
      return "/api/cms/zxjy/subject/xlsx/" + this.projectInfo.id
    },
    createUploadPdfUrl() {
      return "/api/cms/zxjy/project/" + this.projectInfo.id
    },
    createUploadAnswerPhoto() {
      return "/api/cms/zxjy/project/uploadAnswerUrl"
    },
    search() {
      if (!this.projectInfo.id) {
        this.$message.warn('请先选择科目');
        return ;
      }
      this.querySubject();
    },
    reset() {
      this.fuzzyMap = {title:''};
      this.search();
    },
    firstHandleChange(projectId) {
      let projectInfo = this.projectData.filter((item) => item.id == projectId)[0];
      let secondOptions = this.projectData.filter((item) => item.parentId == projectId);
      let firstProjectName = projectInfo.name;
      let secondProjectName = "";
      let thirdProjectName = "";
      let fourthProjectName = "";
      let thirdOptions = [];
      let fourthOptions = [];
      Object.assign(this, {
        firstProjectName
        ,secondOptions
        ,secondProjectName
        ,thirdProjectName
        ,fourthProjectName
        ,thirdOptions
        ,fourthOptions
        ,projectInfo
      });
    },
    secondHandleChange(projectId) {
      let projectInfo = this.projectData.filter((item) => item.id == projectId)[0];
      let secondProjectName = projectInfo.name;
      let thirdOptions = []
      let thirdProjectName = "";
      let fourthProjectName = "";
      let fourthOptions = [];
      let linkType = 0;
      if (projectInfo.isLeaf == 1) {
        linkType = projectInfo.linkType;
      } else {
        thirdOptions = this.projectData.filter((item) => item.parentId == projectId);
      }
      Object.assign(this, {
          secondProjectName
          ,thirdOptions
          ,thirdProjectName
          ,fourthProjectName
          ,fourthOptions
          ,linkType
          ,projectInfo
      });
      if (linkType == 0) {
        this.querySubject();
      }
    },
    thirdHandleChange(projectId) {
      let projectInfo = this.projectData.filter((item) => item.id == projectId)[0];
      let thirdProjectName = projectInfo.name;
      let fourthOptions = [];
      let fourthProjectName = "";
      let linkType = 0;
      if (projectInfo.isLeaf == 1) {
        linkType = projectInfo.linkType;
      } else {
        fourthOptions = this.projectData.filter((item) => item.parentId == projectId);
      }
      Object.assign(this, {
        thirdProjectName
          ,fourthProjectName
          ,fourthOptions
          ,linkType
          ,projectInfo
        });
        
        if (linkType == 0) {
          this.querySubject();
        }
    },
    fourthHandleChange(projectId) {
      let projectInfo = this.projectData.filter((item) => item.id == projectId)[0];
      let fourthProjectName = projectInfo.name;
      let linkType = projectInfo.linkType;
      Object.assign(this, {
        fourthProjectName, linkType, projectInfo
      });
      if (linkType == 0) {
        this.querySubject();
      }
    },
    handleChange (projectId) {
      let parent = this.options.filter((item) => item.id == projectId)[0];
      let leafOptions = parent.dtos;
      let parentProject = parent.name;
      let firstProjet = parent.name;
      Object.assign(this, {
        leafOptions, parentProject, firstProjet
      });
      this.leafHandleChange(leafOptions[0].id)
    },
    leafHandleChange (projectId) {
      let projectInfo = this.leafOptions.filter((item) => item.id == projectId)[0];
      let leafProject = projectInfo.name;
      let linkType = projectInfo.linkType;
      Object.assign(this, {
        projectInfo, leafProject, linkType
      });
      if (linkType == 0) {
        this.querySubject();
      }
    },
    /**
     * 
     */
    showSetUrlModal() {
      if (!this.projectInfo.id) {
        this.$message.warn('请先选择科目');
        return ;
      }
      if (this.projectInfo.linkType != 1) {
        this.$message.warn('此科目不能设置跳转地址');
      } else {
        this.setUrlModalVisible = true;
      }
      
    },
    updateProjectUrl() {
      project.updateJumpUrl(this.projectInfo)
        .then(() => {
          this.$message.success('跳转地址设置成功');
          this.setUrlModalVisible = false;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    
    showUploadFileModal() {
      if (!this.projectInfo.id) {
        this.$message.warn('请先选择科目');
        return ;
      }
      if (this.projectInfo.linkType != 2) {
        this.$message.warn('此科目不能上传文件');
      } else {
        if (this.projectInfo.url) {
          this.$message.warn("此科目已经上传过文件，此次操作会覆盖之前的文件");
        }
        this.fileList = [];
        this.uploadPdfModalVisible = true;
      }
    },
    
    viewFile() {
      if (!this.projectInfo.id) {
        this.$message.warn('请先选择科目');
        return ;
      }
      if (this.projectInfo.linkType != 2 && this.projectInfo.linkType != 4) {
        this.$message.warn('此科目不能预览文件');
        return;
      }
      project.getViewUrl(this.projectInfo.id).then((pdfUrl) => {
        console.log("pdfUrl =",pdfUrl)
        if (!pdfUrl.code) {
          window.open(pdfUrl)
        } else {
          this.$message.warn('此科目没有上传对应文件');
        }
      })
      .catch((e) => {
        console.error(e);
      });
    },
    showBatchUploadModal() {
      if (!this.projectInfo.id) {
        this.$message.warn('请先选择科目');
        return ;
      }
      if (this.projectInfo.linkType != 0) {
        this.$message.warn('此科目不能导入题库');
      } else {
        this.fileList = [];
        this.batchUploadModalVisible = true;
      }
      
    },
    beforeUpload(file, fileList) {
      if (fileList.length > 1) {
        return false;
      }
      if (file.size > 2 * 1024 * 1024) {
        this.$message.error('文件大小超过2MB');
        return false;
      }
      this.fileList.push(file);
      return true;
    },
    
    beforePdfUpload(file, fileList) {
      if (fileList.length > 1) {
        return false;
      }
      if (file.size > 4 * 1024 * 1024) {
        this.$message.error('文件大小超过4MB');
        return false;
      }
      this.fileList.push(file);
      return true;
    },

    change({ file, fileList }) {
      if (file.status == 'error') {
        this.$message.error('数据导入失败');
      } else if (file.status == 'done') {
        this.$message.success('数据导入成功');
        this.querySubject();
      }
      this.fileList = fileList;
    },
    
    beforePhotoUpload() {
      return false;
    },
    async titleUploadPhoto(file) {
      let fileListMap = await this.uploadSubjectPhoto(file, "title");
      this.subjectInfo.titleUrl = fileListMap.title[0].url;
    },
    async firstUploadPhoto(file) {
      let fileListMap = await this.uploadSubjectPhoto(file, "first");
      this.subjectInfo.fisrtAnswerUrl = fileListMap.first[0].url;
    },
    async secondUploadPhoto(file) {
      let fileListMap = await this.uploadSubjectPhoto(file, "second");
      this.subjectInfo.secondAnswerUrl = fileListMap.second[0].url;
    },
    async thirdUploadPhoto(file) {
      let fileListMap = await this.uploadSubjectPhoto(file, "third");
      this.subjectInfo.thirdAnswerUrl = fileListMap.third[0].url;
    },
    async fourthUploadPhoto(file){
      let fileListMap = await this.uploadSubjectPhoto(file, "fourth");
      this.subjectInfo.fourthAnswerUrl = fileListMap.fourth[0].url;
    },

    uploadSubjectPhoto(file, fileListMapKey) {
      return new Promise((resolve, reject) => {
        if (file.file.status == 'removed') {
        this.fileListMap[fileListMapKey] = [];
      } else {
        let formData = new FormData()
        formData.append('file', file.file)
        project.uploadAnswerPhonto(formData).then((response)=> {
          let arr = [];
          arr.push(response);
          this.fileListMap[fileListMapKey] = arr;
          resolve(this.fileListMap);
          }).catch((e) => {
            reject(e)
          });
        }
      })
      
    },
    
    downloadTemplate() {
      let a = document.createElement('a');
      a.href = `/题目模板.xlsx`;
      a.download = '题目模板.xlsx';
      a.click();
    },
    // answerSelectChange() {
    //   console.log("subjectInfo=",this.subjectInfo)
    // },
    batchExportExcel() {
      if (this.selectedRowKeys.length > 0) {
        // let params = {
        //   ids: this.selectedRowKeys
        // }
        // batchExportDataSourceInfoExcel(params, "数据源信息导出.xlsx")
        //   .then(() => {
        //     this.$message.success("导出成功")
        //     this.selectedRowKeys = []
        //   })
        //   .catch(() => {})
      } else {
        this.$message.warn('请选中数据');
      }
    },
    // addSubject() {
    //   this.subjectModalTitle = "新增";
    //   this.showSubjectModal = !this.showSubjectModal;
    // },
    addParamLocal() {
      if (!this.paramForm.paramName || !this.paramForm.paramValue) {
        this.$message.warn('请填写名称或者值！');
        return;
      }
      let data = {
        paramName: this.paramForm.paramName,
        paramValue: this.paramForm.paramValue,
        id: this.parmasIndex++,
      };
      for (let i = 0; i < this.paramList.length; i++) {
        if (
          this.paramList[i].paramName == data.paramName &&
          this.paramList[i].paramValue == data.paramValue
        ) {
          this.$message.warn('名称或者值不能同时相同！');
          return;
        }
      }
      this.paramList.push(data);
      this.paramForm.paramName = '';
      this.paramForm.paramValue = '';
    },
    deleteParam(id) {
      this.paramList = this.paramList.filter((item) => item.id !== id);
    },
    modifyParam(id, index) {
      alert('modify' + index);
      this.$message.success('修改');
    },
    resetParam() {
      this.paramForm.paramName = '';
      this.paramForm.paramValue = '';
    },
    showModalAuthorize(curItem) {
      this.username = '';
      this.curItem = curItem;
      this.findAuth(this.curItem.id);
      this.setUrlModalVisible = true;
    },

    onShowSizeChangeAuth(page, pageSize) {
      this.pageAuth = page;
      this.pageSizeAuth = pageSize;
      this.findAuth(this.curItem.id);
    },
    pageChangeAuth() {
      this.findAuth(this.curItem.id);
    },
    onChangeSwitch(checked, t, r) {
      r[t] = !r[t];
    },
    searchAuthName() {
      if (this.username) {
        this.auth = this.auth.filter((item) => {
          return item.name
            .toString()
            .toLowerCase()
            .includes(this.username.toLowerCase());
        });
      }
    },
    resetAuthName() {
      this.username = '';
      this.findAuth();
    },
    handleResizeColumn(w, col) {
  col.width = w;
},

    onShowSizeChange(page, pageSize) {
      this.page = page;
      this.pageSize = pageSize;
      this.querySubject();
    },
    pageChange() {
      this.querySubject();
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    /**
     * 打开删除信息提示窗口
     */
    openDeleteModal() {
      if (this.selectedRowKeys.length < 1) {
        this.$message.warn('请选中需要删除的试题信息');
      } else {
        this.showDeleteModal = true
      }
    },

    /**
     * 删除信息
     */
    deleteSubjectByIds() {
      subject.delete(this.selectedRowKeys)
      .then(() => {
        this.$message.success("删除成功")
        this.showDeleteModal = false
        this.querySubject()
      })
    },
  }
};
</script>

<style lang="stylus" scoped>
.wrap {
  display: flex;
}
.ant-select{
  width:200px
}
.upload-ele /deep/ .ant-upload-list-item {
  margin-top:0 
}
</style>
